import { CheckCircle } from "lucide-react"

import { Card } from "@/components/ui/card"
import { StatusIcon, StatusType } from "@/components/wb-ui/status-icon"
import {
  BUYER_BEWARE_CARDS,
  dataByBuyerBewareCard,
} from "@/constants/company/buyer-beware-card"
import { getCardCount } from "@/helpers/company/buyer-beware"
import { cn } from "@/lib/utils"

function BuyerBewareCard({
  title,
  count,
  checklistItems,
  isPassed,
}: {
  title: string
  count: number
  checklistItems: readonly string[]
  isPassed: boolean
}) {
  const status = isPassed ? StatusType.GOOD : StatusType.CONCERN
  const textClass = isPassed ? "text-good-foreground" : "text-bad-foreground"

  const reportSuffix = count === 1 ? "" : "s"
  const statusLabel = isPassed
    ? "Passed screening"
    : `${count} report${reportSuffix}`

  return (
    <Card className={cn("flex-1 space-y-4 p-6")}>
      <div className="flex items-start gap-4">
        <StatusIcon status={status} />
        <div>
          <h4 className="wb-h6">{title}</h4>
          <p className={cn("text-sm font-bold uppercase", textClass)}>
            {statusLabel}
          </p>
        </div>
      </div>
      <div className="">We checked for:</div>
      <div className="grid grid-cols-1 gap-x-4 gap-y-1">
        {checklistItems.map((item) => (
          <div key={item} className="flex items-center gap-2">
            <CheckCircle className="text-good-foreground size-4" /> {item}
          </div>
        ))}
      </div>
    </Card>
  )
}

export function BuyerBewareSection({
  deceptionCounts,
}: {
  deceptionCounts: Record<string, number>
}) {
  const combinedCount = BUYER_BEWARE_CARDS.reduce(
    (sum, card) =>
      sum +
      getCardCount(deceptionCounts, dataByBuyerBewareCard[card].deceptionTypes),
    0
  )
  const isPassed = combinedCount < 6

  return (
    <div className="flex flex-col gap-4 md:flex-row">
      {BUYER_BEWARE_CARDS.map((card) => {
        const config = dataByBuyerBewareCard[card]
        return (
          <BuyerBewareCard
            key={card}
            title={config.title}
            count={getCardCount(deceptionCounts, config.deceptionTypes)}
            checklistItems={config.checklistItems}
            isPassed={isPassed}
          />
        )
      })}
    </div>
  )
}
